import React, { useEffect } from 'react';
import { List } from '@mui/material';
import styled from 'styled-components';
import CameraSelection from './CameraSelection';
import MicrophoneSelection from './MicrophoneSelection';
import SpeakerSelection from './SpeakerSelection';
import Messages from '../../../config/messages.constants';
import { useSelfViewContext, useTwilioUserMediaContext } from '../../../customer-call-sdk';

const StyledDeviceSetting = styled.section`
    .title {
        font-weight: bold;
        margin-top: 1rem;
    }
`;
/**
 * Device Setting section container component
 */
const DeviceSetting: React.FC = () => {
    const {
        isMediaPermissionGranted,
        startMedia,
        audioDeviceId,
        videoDeviceId,
    } = useTwilioUserMediaContext();
    const { turnedOff } = useSelfViewContext();

    useEffect(() => {
        if (turnedOff && isMediaPermissionGranted && audioDeviceId && videoDeviceId) {
            startMedia({ audioDeviceId, videoDeviceId, type: 'exact' });
        }
    }, []);

    return (
        <StyledDeviceSetting id="device-setting-section" data-testid="device-setting-section">
            <h6 className="title">{Messages.DEVICE_SETTING_TITLE}</h6>
            <List id="device-setting-list" data-testid="device-setting-list">
                <CameraSelection />
                <MicrophoneSelection />
                <SpeakerSelection />
            </List>
        </StyledDeviceSetting>
    );
};

export default DeviceSetting;
